import React, { useEffect, useState } from "react";
import axios from "axios";
import "./DetailGaleri.scss";
import { useParams, useHistory } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { config } from "../../config";
import LoadingOverlay from "../../component/LoadingOverlay";

const DetailGaleri = () => {
  const { id } = useParams();
  const history = useHistory();
  const [kegiatan, setKegiatan] = useState(null);
  const [kegiatanDetail, setKegiatanDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleBackClick = (e) => {
    e.preventDefault();
    history.push("/");
    setTimeout(() => {
      const element = document.getElementById("galery");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${config.BASE_URL}Kegiatan/webFindOne/${id}`
        );
        const data = res.data.data;
        setKegiatan(data.kegiatan);
        setKegiatanDetail(data.kegiatanDetail || []);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching kegiatan:", err);
        setError("Gagal memuat data kegiatan.");
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <LoadingOverlay />
        <p style={{ color: "#F1582E", marginTop: "10px", fontWeight: "bold" }}>
          Harap Tunggu Sesaat...
        </p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <section id="DetailGaleri">
      <div className="navbar">
        <a href="#" onClick={handleBackClick} className="link-back">
          <FeatherIcon icon="arrow-left" />
          Kembali
        </a>
      </div>

      <div className="container">
        <div className="news-content">
          <h2>{kegiatan?.tujuanKegiatan}</h2>

          <p className="news-date">
            {new Date(kegiatan?.tanggalKegiatan).toLocaleDateString("id-ID", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          {/* Galeri gambar */}
          {kegiatanDetail.length > 0 ? (
            <div className="galeri-foto">
              {kegiatanDetail.map((item, index) => (
                <img
                  key={index}
                  src={
                    item.foto
                      ? `${
                          config.BASE_URL
                        }getReferenceFile?pathFile=${encodeURIComponent(
                          item.foto
                        )}`
                      : "/assets/images/default.png"
                  }
                  alt={`Foto ${index + 1}`}
                  className="galeri-foto-item"
                />
              ))}
            </div>
          ) : (
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              Tidak ada gambar tersedia.
            </p>
          )}

          <p className="news-description">{kegiatan?.deskripsiKegiatan}</p>

          <div className="author-info">
            <p>
              Dipublikasikan oleh: <strong>{kegiatan?.createdName}</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DetailGaleri;
